// import { createRouter, createWebHistory } from 'vue-router'

import {createRouter, createWebHistory,createWebHashHistory,useRouter} from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/classification',
    name: 'class',
    component: () => import('../views/classificationView.vue') 
  },
  {
    path: '/quickorder',
    name: 'quickorder',
    component:()=> import('../views/quickorderView.vue')
  }, {
    path: '/mine',
    name: 'mine',
    component:()=> import('../views/mineView.vue')
  }, {
    path: '/shopCart',
    name: 'shopCart',
    component:()=> import('../views/shoppcartView.vue')
  },{
    path: '/detail',
    name: 'goodsDetail',
    component:()=> import('../views/goodsDetail.vue')
  },{
    path: '/ordermanage',
    name: 'orderManage',
    component:()=> import('../views/orderManagement.vue')
  },{
    path: '/login',
    name: 'loginView',
    component:()=> import('../views/loginView.vue')
  },{
    path: '/map',
    name: 'mapView',
    component:()=> import('../components/map.vue')
  },{
    path: '/orderSubmit',
    name: 'orderSubmitView',
    component:()=> import('../views/ordersubmitView.vue')
  },{
    path: '/submitResults',
    name: 'submitResults',
    component:()=> import('../views/submitResults.vue')
  },{
    path: '/orderDetail',
    name: 'orderDetail',
    component:()=> import('../views/orderdetailView.vue')
  },{
    path: '/receiptVerification',
    name: 'receiptVerification',
    component:()=> import('../views/receiptVerification.vue')
  },{
    path: '/search',
    name: 'searchView',
    component:()=> import('../views/searchView.vue')
  },{
    path: '/todayReceipt',
    name: 'todayReceipt',
    component:()=> import('../views/todayReceipt.vue')
  },{
    path: '/todayOrder',
    name: 'todayOrder',
    component:()=> import('../views/todyOrder.vue')
  },{
    path: '/aboutUs',
    name: 'aboutUs',
    component:()=> import('../views/aboutUs.vue')
  },{
    path: '/afterSales',
    name: 'afterSalesView',
    component:()=> import('../views/afterSalesView.vue')
  },{
    path: '/termService',
    name: 'termService',
    component:()=> import('../views/termService.vue')
  },{
    path: '/bill',
    name: 'billView',
    component:()=> import('../views/billView.vue')
  },{
    path: '/myReport',
    name: 'myReport',
    component:()=> import('../views/myReport.vue')
  },{
    path: '/set',
    name: 'setView',
    component:()=> import('../views/setView.vue')
  },{
    path: '/edituserinfo',
    name: 'edituserinfo',
    component:()=> import('../views/editMinedata.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
